import type { FC } from "react";

import { GetUpdatesPill } from "~/feature/getUpdates/components/GetUpdatesPill";
import { GetUpdatesSheet } from "~/feature/getUpdates/components/GetUpdatesSheet";

import { useGetUpdatesCta } from "./useGetUpdatesCta";

export const GetUpdatesCta: FC = () => {
  const { open, raised, handleOpen, handleClose } = useGetUpdatesCta();

  return (
    <>
      {open ? null : <GetUpdatesPill raised={raised} onClick={handleOpen} />}
      <GetUpdatesSheet open={open} onClose={handleClose} />
    </>
  );
};
